import { CardContainer, TitleContainer, TextContainer } from "./Card.styles";
const Card = () => {
  return (
    <CardContainer>
      <TitleContainer>What's your dream?</TitleContainer>
      <TextContainer>
        Log in now and learn the skills to help make it happen.
      </TextContainer>
    </CardContainer>
  );
};

export default Card;
